import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class StoneBridgeTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.STONE_BRIDGE_1;
}

export default StoneBridgeTileEntity1;
